"use client";

import React from "react";
import { Image as CImage } from "antd";

interface IProps {
  src: any;
  preview: boolean;
  alt: string
}

const AntImage: React.FC<IProps> = ({ src, preview, alt }) => (
  <CImage src={src} 
    preview={preview ? { mask: "Xem hình ảnh" } : false}
    alt={alt}
  />
);

export default AntImage;
